import styled from 'styled-components';

export const WrapperMenu = styled.div`
    position: relative;
`;

export const MenuList = styled.ul`
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
    position: absolute;
    z-index: 10;
    top: 16px;
    right: 0;
`;

export const StyledMenuDeprecatedList = styled(MenuList)<{ isVisible: boolean }>`
    box-sizing: border-box;
    max-width: 250px;
    min-width: 150px;
    width: 100%;
    padding: 4px 0;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.24) 0 16px 24px;
    margin-top: 10px;
    border-radius: 8px;
    background: ${props => props.theme.root.colors.background['02Second']};
    visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
`;
